export default "__VITE_ASSET__31c64e33__"